import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")

import { ref, reactive, onBeforeMount, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, getNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/bad_debt/finance/recharge/query': fetchList,
} = Api

let seleRows = ref([])
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_height
} = new tbMix(fetchList)

const searchEle = ref()
const searchObj = reactive({
  owner: '', customer: '', orderNo: '',
})
const searchHandle = () => {
  fetchData(searchObj)
}
searchHandle()




return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "searchEle",
              ref: searchEle,
              model: _unref(searchObj),
              inline: "",
              class: "searchBg",
              disabled: _unref(MI_identify)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "订单号:",
                  prop: "orderNo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).orderNo,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).orderNo) = $event)),
                      clearable: "",
                      maxlength: "100",
                      placeholder: "请输入订单号",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户名称:",
                  prop: "customer"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).customer,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).customer) = $event)),
                      clearable: "",
                      maxlength: "100",
                      placeholder: "请输入客户名称",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户经理:",
                  prop: "owner"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).owner,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).owner) = $event)),
                      clearable: "",
                      maxlength: "100",
                      placeholder: "请输入客户经理",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_1,
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (searchHandle())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (searchEle.value.resetFields()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      onSelectionChange: _cache[5] || (_cache[5] = (rows) => _isRef(seleRows) //@ts-ignore
 ? seleRows.value = rows : seleRows = rows),
      "max-height": _unref(MI_height) - 30 + 'px',
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "订单号",
          prop: "no",
          "min-width": "100",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单名称",
          prop: "name",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户ID",
          prop: "customerUsername",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户名称",
          prop: "customer",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户联系人",
          prop: "customerContactor",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户经理",
          prop: "owner",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "currency",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "金额",
          prop: "amount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "本位币",
          prop: "standardMoney",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "确认坏账时间",
          prop: "confirmTime",
          "min-width": "125",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "重新收款时间",
          prop: "rechargeTime",
          "min-width": "125",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "操作人",
          prop: "operationName"
        }),
        _createVNode(_component_el_table_column, {
          label: "开始日期",
          prop: "startTime",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "交付日期",
          prop: "deliverTime",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单状态",
          prop: "status"
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      total: _unref(MI_total),
      background: "",
      small: "",
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[6] || (_cache[6] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-sizes": [30, 50, 100, 300],
      class: "mt-10",
      disabled: _unref(MI_identify),
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "page-size", "currentPage", "disabled", "onCurrentChange", "onSizeChange"])
  ]))
}
}

})